import React, { useEffect } from 'react'
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Box, Button, Typography, ImageListItem, ImageList } from "@mui/material";
import { WorkRegistrationType } from '../DataFetch/useWorkRegistration';
import { useWorkImage } from '../DataFetch/useWorkImage';
import { useWorkImageUploadDialog } from '../Component/useWorkImageUploadDialog';

interface PropsType {
    editData:WorkRegistrationType | undefined,
    // CompleteEdit:() => void,
    setEditing:(editing:boolean) => void    
}

export function WorkRegistrationEdit({editData, setEditing}:PropsType) {

    const {workImage, isLoading, mutate} = useWorkImage(editData?.artwork_id);

    const {openUploadDialog, UploadDialog, isComplete} = useWorkImageUploadDialog(editData?.artwork_id);

    useEffect(() => {
        if(isComplete) {
            mutate();
        }
    },[isComplete, mutate])

    function ItemRow(title:string, value:string | number | undefined) {
        return(
            <>
                <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                    <Grid2 xs={12} sm={6}>
                        <Typography variant="body1" sx={{textAlign:{xs:"none",sm:"right"}}}>
                            {title}
                        </Typography>  
                    </Grid2>
                    <Grid2 xs={12} sm={6}>
                        <Typography variant="body1" sx={{textAlign:{xs:"none",sm:"left"}}}>
                            {value === null ? "null" : value}
                        </Typography> 
                    </Grid2>
                </Grid2>
            </>
        );
    }

    function WorkItem(title:string) {
        return(
            <>
                <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                    <Grid2 xs={12} sm={6}>
                        <Typography variant="body1" sx={{textAlign:{xs:"none",sm:"right"}}}>
                            {title}
                        </Typography>  
                    </Grid2>
                    <Grid2 xs={12} sm={6}>
                        <ImageList sx={{width:"100%"}} cols={1} rowHeight={400}>
                            <ImageListItem>
                                {!isLoading && <img src={workImage} alt="workimage"/>}
                            </ImageListItem>
                        </ImageList>
                    </Grid2>
                </Grid2>
            </>
        );
    }

    return(
        <>
            {ItemRow("作品ID　　　　　　", editData?.artwork_id)}
            {ItemRow("国名　　　　　　　", editData?.country_name)}
            {ItemRow("メールアドレス　　", editData?.mailaddress)}
            {ItemRow("グループ　　　　　", editData?.group_flg)}
            {ItemRow("グループ人数　　　", editData?.group_num)}
            {ItemRow("製品化の興味　　　", editData?.interest_work)}
            {ItemRow("作品PDFファイル名 ", editData?.pdf_file_name)}            
            {ItemRow("代表者名前　　　　", editData?.poster1)}
            {ItemRow("代表者生年月日　　", editData?.birthday1)}
            {ItemRow("代表者国名　　　　", editData?.country_name1)}
            {ItemRow("代表者教育機関名　", editData?.educational_institution1)}
            {ItemRow("代表者教育機関国名", editData?.educational_institution_country_name1)}

            {WorkItem("作品データ　　　　")}

            <Box m={1}>
                <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                    <Grid2>
                        <Button variant="outlined" onClick={() => setEditing(false)}>
                            戻る
                        </Button>
                    </Grid2>
                    <Grid2>
                        <Button variant="contained" onClick={openUploadDialog}>
                            作品データ更新
                        </Button>
                    </Grid2>
                    {/* <Grid2>
                        <Button type="submit" variant="contained">
                            保存
                        </Button>
                    </Grid2> */}
                    {/* <Grid2 display={isNew ? "none" : ""}>
                        <Button variant="contained" color="error" onClick={DeleteCountry}>
                            削除
                        </Button>
                    </Grid2>                      */}
                </Grid2>
            </Box>  

            <UploadDialog/>
        </>
    );
}